namespace GeniuzPOS.PosShift {
    export interface ReportVatRefundForm {
        RowNo: Serenity.IntegerEditor;
        DocDate: Serenity.DateEditor;
        BookNo: Serenity.StringEditor;
        No: Serenity.StringEditor;
        FristName: Serenity.StringEditor;
        Passport: Serenity.StringEditor;
        Total: Serenity.DecimalEditor;
        PayVatAmount: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
    }

    export class ReportVatRefundForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.ReportVatRefund';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportVatRefundForm.init)  {
                ReportVatRefundForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(ReportVatRefundForm, [
                    'RowNo', w0,
                    'DocDate', w1,
                    'BookNo', w2,
                    'No', w2,
                    'FristName', w2,
                    'Passport', w2,
                    'Total', w3,
                    'PayVatAmount', w3,
                    'Remark', w2
                ]);
            }
        }
    }
}
